import { render, staticRenderFns } from "./ServiceOrdersTopbarIndicator.vue?vue&type=template&id=1d6f0470"
import script from "./ServiceOrdersTopbarIndicator.vue?vue&type=script&lang=js"
export * from "./ServiceOrdersTopbarIndicator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports